<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/gaji-periode">Daftar Periode Penggajian</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Daftar Riwayat Gaji
        </li>
      </ol>
    </nav>

    <div class="content-block">
      <div class="row">
        <h5>Daftar Riwayat Gaji</h5>
      </div>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <p class="text-muted font-weight-light">Cari Nama Pegawai:</p>
        <div class="row">
          <!-- <div class="editors"> -->
          <div class="editors-container">
            <div class="col">
              <DxTextBox
                :styling-mode="stylingMode"
                :label-mode="labelMode"
                width="100%"
                label="Cari nama pegawai"
                placeholder="nama"
                v-model="cariNamaPegawai"
              >
                <DxValidator>
                  <DxRequiredRule />
                </DxValidator>
              </DxTextBox>
            </div>

            <div class="col" style="padding-left: 10px">
              <DxButton
                @click="lihatGajiPegawai"
                text="Lihat Gaji Pegawai"
                styling-mode="filled"
                type="default"
                class="validate"
                style="float: left"
              />
            </div>
            <div class="col" style="padding-left: 10px">
              <DxButton
                icon="refresh"
                @click="resetFilter()"
                text="Hilangkan pencarian"
                type="danger"
                style="float: right"
                styling-mode="outlined"
              ></DxButton>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxTabPanel
          id="tabpanel"
          :data-source="tabSource"
          v-model:selected-index="tabPanelIndex"
          :loop="loop"
          :animation-enabled="animationEnabled"
          :swipe-enabled="swipeEnabled"
          item-title-template="title"
          @titleClick="tabTitleClick"
        >
          <template #title="{ data: item }">
            <span class="tab-panel-title">{{ item.text }}</span>
          </template>

          <template #tDireksi>
            <DxDataGrid
              ref="gridRefDireksi"
              id="gridTDireksi"
              :data-source="dataSourceDireksi"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @option-changed="onPageChanged($event, 'gridRefDireksi')"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              :focused-row-enabled="true"
              :focused-row-index="0"
              :filter-value="filterValue"
              :filter-sync-enabled="true"
              @row-prepared="rowPrepared($event)"
              @context-menu-preparing="onContextMenuPreparing"
            >
              <DxFilterRow :visible="true" :apply-filter="currentFilter" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" />

              <DxToolbar>
                <DxItem location="after" template="refresh-template" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('gridRefDireksi')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>
              <!-- <DxSelection mode="multiple" /> -->
              <DxColumnFixing :enabled="true" />

              <DxColumn
                type="buttons"
                :fixed="true"
                fixed-position="right"
                :allow-hiding="false"
              >
                <DxButtonDatagrid
                  hint="Absen pegawai"
                  icon="event"
                  :visible="true"
                  @click="detailAbsen"
                />
                <DxButtonDatagrid
                  hint="Detail Pegawai"
                  icon="search"
                  :visible="true"
                  @click="detailPegawai"
                />
                <!-- v-if="buttonCan('gaji-update')" -->
                <!-- :visible="can('gaji-update')" -->
              </DxColumn>

              <DxColumn
                :visible="false"
                class="noteditable"
                data-type="boolean"
                data-field="tandai_salah"
                caption="Tandai Salah HALO"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <DxColumn
                data-type="string"
                class="noteditable"
                caption="#"
                data-field="created_at"
                cell-template="numberingTemplate"
                :allow-filtering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <template #numberingTemplate="{ data }">
                {{
                  numberingPageNumber * numberingPageSize + data.rowIndex + 1
                }}
              </template>
              <template #currencyTemplate="{ data }">
                {{ formatNumber(data.value) }}
              </template>
              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="pegawai.nik"
                caption="NIK"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pegawai_id"
                caption="PEGAWAI ID"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :visible="false"
              />
              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="pegawai.nama"
                caption="Nama pegawai"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :min-width="200"
              />
              <DxColumn
                class="noteditable"
                data-field="tgl_gaji"
                caption="Periode Gaji"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :calculate-filter-expression="calculateFilterExpression"
                :filter-operations="filterOperations"
                sort-order="desc"
                cell-template="tglGajiTemplate"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              >
              </DxColumn>

              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="golongan_id"
                caption="Gol."
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="golonganSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-type="string"
                data-field="status_ptkp"
                caption="Status PTKP"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="statusPtkpSource"
                  value-expr="nama"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.jabatan_id"
                caption="Jabatan"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="jabatanSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.cabang_id"
                caption="Cabang"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="cabangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.unit_id"
                caption="Unit"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="unitSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.bagian_id"
                caption="Bagian"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="bagianSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.sub_bagian_id"
                caption="Sub Bagian"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="subBagianSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.bidang_id"
                caption="Bidang"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="bidangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.sub_bidang_id"
                caption="Sub Bidang"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="subBidangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.seksi_id"
                caption="Seksi"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="seksiSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn caption="Jabatan PLT">
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.jabatan_id"
                  caption="Jabatan PLT"
                >
                  <DxLookup
                    :data-source="jabatanSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.cabang_id"
                  caption="Cabang PLT"
                >
                  <DxLookup
                    :data-source="cabangSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.unit_id"
                  caption="Unit PLT"
                >
                  <DxLookup
                    :data-source="unitSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.bagian_id"
                  caption="Bagian PLT"
                >
                  <DxLookup
                    :data-source="bagianSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.sub_bagian_id"
                  caption="Sub Bagian PLT"
                >
                  <DxLookup
                    :data-source="subBagianSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.bidang_id"
                  caption="Bidang PLT"
                >
                  <DxLookup
                    :data-source="bidangSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.sub_bidang_id"
                  caption="Sub Bidang PLT"
                >
                  <DxLookup
                    :data-source="subBidangSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
              </DxColumn>

              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="gaji_pokok"
                caption="Gaji Pokok"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_perusahaan"
                caption="Tunj. Perusahaan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_jabatan"
                caption="Tunj. Jabatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_kemahalan"
                caption="Tunj. Kemahalan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_air"
                caption="Tunj. Air"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_transport"
                caption="Tunj. Transport"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_pangan"
                caption="Tunj. Pangan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_kesehatan"
                caption="Tunj. Kesehatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                data-field="absenBulan.tidak_hadir"
                caption="Jml Tdk Hadir"
                class="noteditable"
                :allow-hiding="false"
              />
              <!-- <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" /> -->
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_5_persen"
                caption="Pot. Tdk Hadir"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="jml_bruto"
                caption="Jml Bruto"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="tun_pph"
                caption="Tunj. PPH"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_kesehatan"
                caption="Pot. Kesehatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_bpjs_tk_tiga_program"
                caption="Pot. BPJS TK 3 Program"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_bpjs_tk_empat_program"
                caption="Pot. BPJS TK 4 Program"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_pensiun"
                caption="Pot. Pensiun IFG LIFE"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_pph"
                caption="Pot. PPH"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="total_diterima"
                caption="Total Diterima"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="boolean"
                class="noteditable"
                data-field="edited_by_user"
                caption="Dibuat oleh"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="editedSource"
                  value-expr="val"
                  display-expr="nama"
              /></DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                caption="Terakhir di update oleh"
                cell-template="updatedTemplate"
              >
              </DxColumn>
              <template #updatedTemplate="{ data }">
                <div v-html="templateUpdateByUser(data)"></div>
              </template>

              <DxColumn
                class="noteditable-ket"
                data-type="string"
                data-field="ket"
                caption="Catatan"
                :allow-hiding="false"
              ></DxColumn>

              <DxSummary>
                <DxTotalItem
                  column="created_at"
                  summary-type="count"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="gaji_pokok"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_perusahaan"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="tun_jabatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kemahalan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_air"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_transport"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pangan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="absenBulan.tidak_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <!-- <DxTotalItem
                  column="jml_tdk_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                /> -->
                <DxTotalItem
                  column="pot_5_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_bruto"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="pot_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_tiga_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_empat_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pensiun"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>

              <template #mkTemplate="{ data }">
                {{ data.text + " tahun" }}
                <!-- {{ data.text }} -->
              </template>
              <template #tglGajiTemplate="{ data }">
                {{ formatMonth(data.text) }}
              </template>
              <DxColumnChooser :enabled="true" :mode="mode">
                <DxPosition
                  my="right top"
                  at="right bottom"
                  of=".dx-datagrid-column-chooser-button"
                />

                <DxColumnChooserSearch
                  :enabled="true"
                  :editor-options="editorOptions"
                />
                <DxColumnChooserSelection
                  :allow-select-all="allowSelectAll"
                  :select-by-click="selectByClick"
                  :recursive="recursive"
                />
              </DxColumnChooser>
            </DxDataGrid>
          </template>
          <template #tTetap>
            <DxDataGrid
              ref="gridRefTetap"
              id="gridTetap"
              :data-source="dataSourceTetap"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @option-changed="onPageChanged($event, 'gridRefTetap')"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              :focused-row-enabled="true"
              :focused-row-index="0"
              :filter-value="filterValue"
              :filter-sync-enabled="true"
              @row-prepared="rowPrepared($event)"
              @context-menu-preparing="onContextMenuPreparing"
            >
              <DxFilterRow :visible="true" :apply-filter="currentFilter" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" />

              <DxToolbar>
                <DxItem location="after" template="refresh-template" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('gridRefTetap')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>
              <!-- <DxSelection mode="multiple" /> -->
              <DxColumnFixing :enabled="true" />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pegawai_id"
                caption="PEGAWAI ID"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :visible="false"
              />
              <DxColumn
                type="buttons"
                :fixed="true"
                fixed-position="right"
                :allow-hiding="false"
              >
                <DxButtonDatagrid
                  hint="Absen pegawai"
                  icon="event"
                  :visible="true"
                  @click="detailAbsen"
                />
                <DxButtonDatagrid
                  hint="Detail Pegawai"
                  icon="search"
                  :visible="true"
                  @click="detailPegawai"
                />
              </DxColumn>

              <DxColumn
                :visible="false"
                data-type="boolean"
                class="noteditable"
                data-field="tandai_salah"
                caption="Tandai Salah"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="string"
                class="noteditable"
                caption="#"
                data-field="created_at"
                cell-template="numberingTemplate"
                :allow-filtering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <template #numberingTemplate="{ data }">
                {{
                  numberingPageNumber * numberingPageSize + data.rowIndex + 1
                }}
              </template>
              <template #currencyTemplate="{ data }">
                {{ formatNumber(data.value) }}
              </template>

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="pegawai.nik"
                caption="NIK"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="pegawai.nama"
                caption="Nama pegawai"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :min-width="200"
              />
              <DxColumn
                class="noteditable"
                data-field="tgl_gaji"
                caption="Periode Gaji"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :calculate-filter-expression="calculateFilterExpression"
                :filter-operations="filterOperations"
                sort-order="desc"
                cell-template="tglGajiTemplate"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              >
              </DxColumn>

              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="golongan_id"
                caption="Gol."
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="golonganSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                data-type="string"
                data-field="status_ptkp"
                caption="Status PTKP"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="statusPtkpSource"
                  value-expr="nama"
                  display-expr="nama"
                />
              </DxColumn>
              <!-- <DxColumn
                class="noteditable"
                data-field="riwayatGolongan"
                caption="Masa Kerja"
                :calculate-display-value="calculateDisplayMK"
                :calculate-filter-expression="calculateFilterMK"
              >
              </DxColumn> -->
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.jabatan_id"
                caption="Jabatan"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="jabatanSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.cabang_id"
                caption="Cabang"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="cabangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.unit_id"
                caption="Unit"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="unitSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.bagian_id"
                caption="Bagian"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="bagianSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.sub_bagian_id"
                caption="Sub Bagian"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="subBagianSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-type="number"
                data-field="riwayatPekerjaan.bidang_id"
                caption="Bidang"
              >
                <DxLookup
                  :data-source="bidangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.sub_bidang_id"
                caption="Sub Bidang"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="subBidangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.seksi_id"
                caption="Seksi"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="seksiSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn caption="Jabatan PLT">
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.jabatan_id"
                  caption="Jabatan PLT"
                >
                  <DxLookup
                    :data-source="jabatanSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.cabang_id"
                  caption="Cabang PLT"
                >
                  <DxLookup
                    :data-source="cabangSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.unit_id"
                  caption="Unit PLT"
                >
                  <DxLookup
                    :data-source="unitSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.bagian_id"
                  caption="Bagian PLT"
                >
                  <DxLookup
                    :data-source="bagianSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.sub_bagian_id"
                  caption="Sub Bagian PLT"
                >
                  <DxLookup
                    :data-source="subBagianSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.bidang_id"
                  caption="Bidang PLT"
                >
                  <DxLookup
                    :data-source="bidangSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
                <DxColumn
                  class="noteditable"
                  data-type="number"
                  data-field="riwayatPlt.sub_bidang_id"
                  caption="Sub Bidang PLT"
                >
                  <DxLookup
                    :data-source="subBidangSource"
                    value-expr="id"
                    display-expr="nama"
                  />
                </DxColumn>
              </DxColumn>
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="gaji_pokok"
                caption="Gaji Pokok"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_perusahaan"
                caption="Tunj. Perusahaan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_jabatan"
                caption="Tunj. Jabatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_kemahalan"
                caption="Tunj. Kemahalan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_air"
                caption="Tunj. Air"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_transport"
                caption="Tunj. Transport"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_pangan"
                caption="Tunj. Pangan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_kesehatan"
                caption="Tunj. Kesehatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                data-field="absenBulan.tidak_hadir"
                caption="Jml Tdk Hadir"
                class="noteditable"
                :allow-hiding="false"
              />
              <!-- <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" /> -->
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_5_persen"
                caption="Pot. Tdk Hadir"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="jml_bruto"
                caption="Jml Bruto"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="tun_pph"
                caption="Tunj. PPH"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_kesehatan"
                caption="Pot. Kesehatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_bpjs_tk_tiga_program"
                caption="Pot. BPJS TK 3 Program"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_bpjs_tk_empat_program"
                caption="Pot. BPJS TK 4 Program"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_pensiun"
                caption="Pot. Pensiun IFG LIFE"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_pph"
                caption="Pot. PPH"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="total_diterima"
                caption="Total Diterima"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="boolean"
                class="noteditable"
                data-field="edited_by_user"
                caption="Dibuat oleh"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="editedSource"
                  value-expr="val"
                  display-expr="nama"
              /></DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                caption="Terakhir di update oleh"
                cell-template="updatedTemplate"
              >
              </DxColumn>
              <template #updatedTemplate="{ data }">
                <div v-html="templateUpdateByUser(data)"></div>
              </template>
              <DxColumn
                class="noteditable-ket"
                data-type="string"
                data-field="ket"
                caption="Catatan"
                :allow-hiding="false"
              ></DxColumn>
              <DxSummary>
                <DxTotalItem
                  column="created_at"
                  summary-type="count"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="gaji_pokok"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_perusahaan"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="tun_jabatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kemahalan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_air"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_transport"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pangan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="absenBulan.tidak_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <!-- <DxTotalItem
                  column="jml_tdk_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                /> -->
                <DxTotalItem
                  column="pot_5_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_bruto"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <DxTotalItem
                  column="pot_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_tiga_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_empat_program"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pensiun"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_pph"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>

              <template #mkTemplate="{ data }">
                {{ data.text + " tahun" }}
                <!-- {{ data.text }} -->
              </template>
              <template #tglGajiTemplate="{ data }">
                {{ formatMonth(data.text) }}
              </template>
              <DxColumnChooser :enabled="true" :mode="mode">
                <DxPosition
                  my="right top"
                  at="right bottom"
                  of=".dx-datagrid-column-chooser-button"
                />

                <DxColumnChooserSearch
                  :enabled="true"
                  :editor-options="editorOptions"
                />
                <DxColumnChooserSelection
                  :allow-select-all="allowSelectAll"
                  :select-by-click="selectByClick"
                  :recursive="recursive"
                />
              </DxColumnChooser>
            </DxDataGrid>
          </template>
          <template #tHonor>
            <DxDataGrid
              ref="gridRefHonor"
              id="gridHonor"
              :data-source="dataSourceHonor"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @option-changed="onPageChanged($event, 'gridRefHonor')"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              :focused-row-enabled="true"
              :focused-row-index="0"
              :filter-value="filterValue"
              :filter-sync-enabled="true"
              @row-prepared="rowPrepared($event)"
              @context-menu-preparing="onContextMenuPreparing"
            >
              <DxFilterRow :visible="true" :apply-filter="currentFilter" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" />

              <DxToolbar>
                <DxItem location="after" template="refresh-template" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('gridRefHonor')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>
              <!-- <DxSelection mode="multiple" /> -->
              <DxColumnFixing :enabled="true" />
              <DxColumn
                type="buttons"
                :fixed="true"
                fixed-position="right"
                :allow-hiding="false"
              >
                <DxButtonDatagrid
                  hint="Absen pegawai"
                  icon="event"
                  :visible="true"
                  @click="detailAbsen"
                />
                <DxButtonDatagrid
                  hint="Detail Pegawai"
                  icon="search"
                  :visible="true"
                  @click="detailPegawai"
                />
              </DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pegawai_id"
                caption="PEGAWAI ID"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :visible="false"
              />
              <DxColumn
                :visible="false"
                data-type="boolean"
                class="noteditable"
                data-field="tandai_salah"
                caption="Tandai Salah"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <DxColumn
                data-type="string"
                class="noteditable"
                caption="#"
                data-field="created_at"
                cell-template="numberingTemplate"
                :allow-filtering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <template #numberingTemplate="{ data }">
                {{
                  numberingPageNumber * numberingPageSize + data.rowIndex + 1
                }}
              </template>
              <template #currencyTemplate="{ data }">
                {{ formatNumber(data.value) }}
              </template>
              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="pegawai.nik"
                caption="NIK"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="pegawai.nama"
                caption="Nama pegawai"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :min-width="200"
              />
              <DxColumn
                class="noteditable"
                data-field="tgl_gaji"
                caption="Periode Gaji"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :calculate-filter-expression="calculateFilterExpression"
                :filter-operations="filterOperations"
                sort-order="desc"
                cell-template="tglGajiTemplate"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              >
              </DxColumn>

              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="golongan_id"
                caption="Gol."
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="golonganSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.jabatan_id"
                caption="Jabatan"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="jabatanSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.cabang_id"
                caption="Cabang"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="cabangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.unit_id"
                caption="Unit"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="unitSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.bagian_id"
                caption="Bagian"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="bagianSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.sub_bagian_id"
                caption="Sub Bagian"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="subBagianSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-type="number"
                data-field="riwayatPekerjaan.bidang_id"
                caption="Bidang"
              >
                <DxLookup
                  :data-source="bidangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.sub_bidang_id"
                caption="Sub Bidang"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="subBidangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.seksi_id"
                caption="Seksi"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="seksiSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                class="noteditable"
                data-field="pegawai.tgl_mulai_bekerja"
                caption="TMT Kontrak"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                :allow-hiding="false"
              />

              <DxColumn
                class="noteditable"
                data-type="number"
                data-field="masa_kerja"
                caption="Masa Kerja"
                cell-template="mkTemplate"
                :allow-hiding="false"
              />

              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="honor_umk_jml"
                caption="Honor (UMK)"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />

              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="kenaikan_masa_kerja"
                caption="Kenaikan Masa Kerja"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_kesehatan"
                caption="Tunj. Kesehatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                data-field="absenBulan.tidak_hadir"
                caption="Jml Tdk Hadir"
                class="noteditable"
                :allow-hiding="false"
              />

              <!-- <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" /> -->
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_5_persen"
                caption="Pot. Tdk Hadir"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="jml_bruto"
                caption="Jml Bruto"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_kesehatan"
                caption="Pot. Kesehatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_bpjs_tk_dua_persen"
                caption="Pot. BPJS TK 2%"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="total_diterima"
                caption="Total Diterima"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="boolean"
                class="noteditable"
                data-field="edited_by_user"
                caption="Dibuat oleh"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="editedSource"
                  value-expr="val"
                  display-expr="nama"
              /></DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                caption="Terakhir di update oleh"
                cell-template="updatedTemplate"
              >
              </DxColumn>
              <template #updatedTemplate="{ data }">
                <div v-html="templateUpdateByUser(data)"></div>
              </template>
              <DxColumn
                data-type="string"
                data-field="ket"
                caption="Catatan"
                :allow-hiding="false"
                class="noteditable-ket"
              ></DxColumn>

              <DxSummary>
                <DxTotalItem
                  column="created_at"
                  summary-type="count"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="honor_umk_jml"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="kenaikan_masa_kerja"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="absenBulan.tidak_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <!-- <DxTotalItem
                  column="jml_tdk_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                /> -->
                <DxTotalItem
                  column="pot_5_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_bruto"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_dua_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>

              <template #mkTemplate="{ data }">
                {{ data.text + " tahun" }}
                <!-- {{ data.text }} -->
              </template>
              <template #tglGajiTemplate="{ data }">
                {{ formatMonth(data.text) }}
              </template>
              <DxColumnChooser :enabled="true" :mode="mode">
                <DxPosition
                  my="right top"
                  at="right bottom"
                  of=".dx-datagrid-column-chooser-button"
                />

                <DxColumnChooserSearch
                  :enabled="true"
                  :editor-options="editorOptions"
                />
                <DxColumnChooserSelection
                  :allow-select-all="allowSelectAll"
                  :select-by-click="selectByClick"
                  :recursive="recursive"
                />
              </DxColumnChooser>
            </DxDataGrid>
          </template>
          <template #tKontrak>
            <DxDataGrid
              ref="gridRefKontrak"
              :data-source="dataSourceKontrak"
              :allow-column-reordering="true"
              :show-borders="true"
              key-expr="id"
              :show-column-lines="false"
              :column-auto-width="true"
              :column-hiding-enabled="false"
              @option-changed="onPageChanged($event, 'gridRefKontrak')"
              @exporting="onExporting"
              @editor-preparing="oneditorpreparing"
              :focused-row-enabled="true"
              :focused-row-index="0"
              :filter-value="filterValue"
              :filter-sync-enabled="true"
              @row-prepared="rowPrepared($event)"
              @context-menu-preparing="onContextMenuPreparing"
            >
              <DxFilterRow :visible="true" :apply-filter="currentFilter" />
              <dx-pager :show-page-size-selector="true" :show-info="true" />
              <DxPaging :enabled="true" :page-size="numberingPageSize" />
              <DxExport :enabled="true" />

              <DxToolbar>
                <DxItem location="after" template="refresh-template" />
                <DxItem name="exportButton" />
                <DxItem name="columnChooserButton" />
              </DxToolbar>
              <template #refresh-template>
                <DxButton
                  icon="refresh"
                  @click="refreshDatagrid('gridRefKontrak')"
                  text="Refresh Data"
                  type="default"
                  style="float: left"
                  width="160px"
                  styling-mode="outlined"
                ></DxButton>
              </template>
              <!-- <DxSelection mode="multiple" /> -->
              <DxColumnFixing :enabled="true" />
              <DxColumn
                type="buttons"
                :fixed="true"
                fixed-position="right"
                :allow-hiding="false"
              >
                <DxButtonDatagrid
                  hint="Absen pegawai"
                  icon="event"
                  :visible="true"
                  @click="detailAbsen"
                />
                <DxButtonDatagrid
                  hint="Detail Pegawai"
                  icon="search"
                  :visible="true"
                  @click="detailPegawai"
                />
              </DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pegawai_id"
                caption="PEGAWAI ID"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :visible="false"
              />
              <DxColumn
                :visible="false"
                data-type="boolean"
                class="noteditable"
                data-field="tandai_salah"
                caption="Tandai Salah"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <DxColumn
                data-type="string"
                class="noteditable"
                caption="#"
                data-field="created_at"
                cell-template="numberingTemplate"
                :allow-filtering="false"
                :allow-sorting="false"
                :allow-exporting="false"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <template #numberingTemplate="{ data }">
                {{
                  numberingPageNumber * numberingPageSize + data.rowIndex + 1
                }}
              </template>
              <template #currencyTemplate="{ data }">
                {{ formatNumber(data.value) }}
              </template>
              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="pegawai.nik"
                caption="NIK"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              />

              <DxColumn
                data-type="string"
                class="noteditable"
                data-field="pegawai.nama"
                caption="Nama pegawai"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
                :min-width="200"
              />

              <DxColumn
                class="noteditable"
                data-field="tgl_gaji"
                caption="Periode Gaji"
                data-type="date"
                :display-format="'MM/yyyy'"
                :format="'MM/yyyy'"
                :calculate-filter-expression="calculateFilterExpression"
                :filter-operations="filterOperations"
                sort-order="desc"
                cell-template="tglGajiTemplate"
                :fixed="true"
                fixed-position="left"
                :allow-hiding="false"
              >
              </DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="golongan_id"
                caption="Gol."
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="golonganSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.jabatan_id"
                caption="Jabatan"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="jabatanSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.cabang_id"
                caption="Cabang"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="cabangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.unit_id"
                caption="Unit"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="unitSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.bagian_id"
                caption="Bagian"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="bagianSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.sub_bagian_id"
                caption="Sub Bagian"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="subBagianSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                class="noteditable"
                data-type="number"
                data-field="riwayatPekerjaan.bidang_id"
                caption="Bidang"
              >
                <DxLookup
                  :data-source="bidangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.sub_bidang_id"
                caption="Sub Bidang"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="subBidangSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="riwayatPekerjaan.seksi_id"
                caption="Seksi"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="seksiSource"
                  value-expr="id"
                  display-expr="nama"
                />
              </DxColumn>

              <DxColumn
                class="noteditable"
                data-field="pegawai.tgl_mulai_bekerja"
                caption="TMT Kontrak"
                data-type="date"
                :display-format="'dd/MM/yyyy'"
                :format="'dd/MM/yyyy'"
                :allow-hiding="false"
              />

              <DxColumn
                class="noteditable"
                data-type="number"
                data-field="masa_kerja"
                caption="Masa Kerja"
                cell-template="mkTemplate"
                :allow-hiding="false"
              />

              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="honor_umk_jml"
                caption="Honor (UMK)"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="kenaikan_masa_kerja"
                caption="Kenaikan Masa Kerja"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                class="noteditable-gaji"
                data-type="number"
                data-field="tun_kesehatan"
                caption="Tunj. Kesehatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                data-field="absenBulan.tidak_hadir"
                caption="Jml Tdk Hadir"
                class="noteditable"
                :allow-hiding="false"
              />
              <!-- <DxColumn data-field="jml_tdk_hadir" caption="Jml Tidak Hadir" /> -->
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_5_persen"
                caption="Pot. Tdk Hadir"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="tun_bpjs_tk_satu_sembilanbelas_persen"
                caption="Tunj. BPJS TK 1.19%"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="jml_bruto"
                caption="Jml Bruto"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_kesehatan"
                caption="Pot. Kesehatan"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="pot_bpjs_tk_satu_sembilanbelas_persen"
                caption="Pot. BPJS TK 1.19%"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="number"
                class="noteditable"
                data-field="total_diterima"
                caption="Total Diterima"
                cell-template="currencyTemplate"
                :allow-hiding="false"
              />
              <DxColumn
                data-type="boolean"
                class="noteditable"
                data-field="edited_by_user"
                caption="Dibuat oleh"
                :allow-hiding="false"
              >
                <DxLookup
                  :data-source="editedSource"
                  value-expr="val"
                  display-expr="nama"
              /></DxColumn>
              <DxColumn
                data-type="number"
                class="noteditable"
                caption="Terakhir di update oleh"
                cell-template="updatedTemplate"
              >
              </DxColumn>
              <template #updatedTemplate="{ data }">
                <div v-html="templateUpdateByUser(data)"></div>
              </template>
              <DxColumn
                class="noteditable-ket"
                data-type="string"
                data-field="ket"
                caption="Catatan"
                :allow-hiding="false"
              ></DxColumn>
              <DxSummary>
                <DxTotalItem
                  column="created_at"
                  summary-type="count"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="honor_umk_jml"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="kenaikan_masa_kerja"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="absenBulan.tidak_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                />

                <!-- <DxTotalItem
                  column="jml_tdk_hadir"
                  summary-type="sum"
                  value-format="#,##0"
                /> -->
                <DxTotalItem
                  column="pot_5_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="tun_bpjs_tk_satu_sembilanbelas_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="jml_bruto"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_kesehatan"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="pot_bpjs_tk_satu_sembilanbelas_persen"
                  summary-type="sum"
                  value-format="#,##0"
                />
                <DxTotalItem
                  column="total_diterima"
                  summary-type="sum"
                  value-format="#,##0"
                />
              </DxSummary>
              <template #mkTemplate="{ data }">
                {{ data.text + " tahun" }}
                <!-- {{ data.text }} -->
              </template>
              <template #tglGajiTemplate="{ data }">
                {{ formatMonth(data.text) }}
              </template>
              <DxColumnChooser :enabled="true" :mode="mode">
                <DxPosition
                  my="right top"
                  at="right bottom"
                  of=".dx-datagrid-column-chooser-button"
                />

                <DxColumnChooserSearch
                  :enabled="true"
                  :editor-options="editorOptions"
                />
                <DxColumnChooserSelection
                  :allow-select-all="allowSelectAll"
                  :select-by-click="selectByClick"
                  :recursive="recursive"
                />
              </DxColumnChooser>
            </DxDataGrid>
          </template>
        </DxTabPanel>
      </div>
      <dx-popup
        :visible="popupLoadingVisible"
        title="Generating gaji..."
        :drag-enabled="false"
        :hide-on-outside-click="false"
        width="300"
        :height="130"
      >
        <div class="d-flex justify-content-center">
          <div
            class="spinner-border"
            style="width: 3rem; height: 3rem"
            role="status"
          ></div>
        </div>
      </dx-popup>

      <DxPopup
        :visible="popupWarningVisible"
        :title="popupWarningTitle"
        :drag-enabled="false"
        :hide-on-outside-click="false"
        width="400"
        :height="200"
      >
        <div>
          <p>
            <strong>{{ popupWarningContent }}</strong>
          </p>
        </div>
        <DxToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="before"
          :options="cancelButtonOptions"
        />

        <DxToolbarItem
          widget="dxButton"
          toolbar="bottom"
          location="after"
          :options="confirmButtonOptionsWarning"
        />
      </DxPopup>
    </div>
  </div>
</template>

<style lang="scss">
.class-tandai-salah {
  background-color: rgba(243, 158, 108);
  /* Other styles as needed */
}
.class-tandai-salah td {
  background-color: rgba(
    243,
    158,
    108,
    0.5
  ); /* Ensures cells also have the background */
}
</style>

<script>
import { useCommonStore } from "@/stores/utility/common-store2";
import DxTextBox from "devextreme-vue/text-box";
import { DxValidator, DxRequiredRule } from "devextreme-vue/validator";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import router from "@/router";
import can from "@/haspermission";
import DxTabPanel from "devextreme-vue/tab-panel";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import DxButton from "devextreme-vue/button";
import {
  DxDataGrid,
  DxColumn,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxColumnFixing,
  // DxSelection,
  DxExport,
  DxToolbar,
  DxItem,
  DxSummary,
  DxTotalItem,
  DxButton as DxButtonDatagrid,
  DxColumnChooser,
  DxColumnChooserSearch,
  DxColumnChooserSelection,
  DxPosition,
} from "devextreme-vue/data-grid";

// import { toHandlerKey } from "vue";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import { DateTime } from "luxon";
import _ from "lodash";
// import { confirm } from "devextreme/ui/dialog";
// import notify from "devextreme/ui/notify";
// import axios from "axios";
// import auth from "@/auth";
// import api from "@/api";
// import { API_BASE_URL } from "@/global-constants";
import { ODATA_BASE_URL } from "@/global-constants";

import { useGolonganStore } from "@/stores/GolonganStore";
import { useJabatanStore } from "@/stores/JabatanStore";
import { useBagianStore } from "@/stores/BagianStore";
import { useBidangStore } from "@/stores/BidangStore";
import { useSubBagianStore } from "@/stores/SubBagianStore";
import { useSubBidangStore } from "@/stores/SubBidangStore";
import { useSeksiStore } from "@/stores/SeksiStore";
import { useCabangStore } from "@/stores/CabangStore";
import { useUnitStore } from "@/stores/UnitStore";
import { usePenggajianStatusStore } from "@/stores/PenggajianStatusStore";
import { useGajiPokokSkemaStore } from "@/stores/GajiPokokSkemaStore";
import { useGajiSkemaDireksiStore } from "@/stores/GajiSkemaDireksiStore";
import { useGajiSkemaTetapStore } from "@/stores/GajiSkemaTetapStore";
import { useGajiSkemaCapegStore } from "@/stores/GajiSkemaCapegStore";
import { useGajiSkemaHonorStore } from "@/stores/GajiSkemaHonorStore";
import { useGajiSkemaKontrakStore } from "@/stores/GajiSkemaKontrakStore";

const tabSource = [
  {
    id: 1,
    text: "Direksi",
    template: "tDireksi",
  },
  {
    id: 2,
    text: "Pegawai Tetap",
    template: "tTetap",
  },
  {
    id: 3,
    text: "Pekerja Honor",
    template: "tHonor",
  },
  {
    id: 4,
    text: "Pekerja Kontrak",
    template: "tKontrak",
  },
];

function hasFilterNestedTable(str) {
  return (
    _.includes(str, "/") ||
    _.includes(str, "[") ||
    _.includes(str, "]") ||
    _.includes(str, "riwayatPekerjaan/") ||
    _.includes(str, "riwayatGolongan/") ||
    _.includes(str, "pegawai/")
  );
}

function convertFilterPegawai(filter) {
  var searchTerm = (filter.match(
    /contains\(tolower\(pegawai\/nama\),'([^']+)'/
  ) || [])[1];
  var replacedString = filter.replace(
    /contains\(tolower\(pegawai\/nama\),'([^']+)'/,
    `pegawai/any(s:(contains(tolower(s/nama),'${searchTerm}'))`
  );

  var searchTermNik = (replacedString.match(
    /contains\(tolower\(pegawai\/nik\),'([^']+)'/
  ) || [])[1];
  var replacedStringNik = replacedString;

  replacedStringNik = replacedString.replace(
    /contains\(tolower\(pegawai\/nik\),'([^']+)'/,
    `pegawai/any(s:(contains(tolower(s/nik),'${searchTermNik}'))`
  );

  return replacedStringNik;
}

function convertFilter(filter, regVar) {
  // const regex = new RegExp(`${regVar}\/(\\w+) eq (\\d+)`, "g"); //utk detect riwayatPekerjaan/cabang_id eq 2
  const regex = new RegExp(`${regVar}/(\\w+) eq (\\d+)`, "g");
  const outputString = filter.replace(regex, (match, p1, p2) => {
    return `${regVar}/any(s:s/${p1} eq ${p2})`;
  });
  return outputString;
}

function getUrlFilter() {
  return router.currentRoute.value.query.filter;
}
export default {
  components: {
    DxTabPanel,
    DxDataGrid,
    DxColumn,

    DxPaging,
    DxFilterRow,
    DxLookup,
    DxPager,
    DxColumnFixing,
    // DxSelection,
    DxExport,
    DxToolbar,
    DxItem,
    DxSummary,
    DxTotalItem,
    DxButton,
    DxButtonDatagrid,
    DxColumnChooser,
    DxColumnChooserSearch,
    DxColumnChooserSelection,
    DxPosition,
    DxPopup,
    DxToolbarItem,
    DxTextBox,
    DxValidator,
    DxRequiredRule,
    // confirm,
  },
  setup() {
    const commonStore = useCommonStore();
    const golonganStore = useGolonganStore();
    const jabatanStore = useJabatanStore();
    const bagianStore = useBagianStore();
    const bidangStore = useBidangStore();
    const subBagianStore = useSubBagianStore();
    const subBidangStore = useSubBidangStore();
    const seksiStore = useSeksiStore();
    const cabangStore = useCabangStore();
    const unitStore = useUnitStore();
    const gajiStatusStore = usePenggajianStatusStore();
    const gajiPokokSkemaStore = useGajiPokokSkemaStore();
    const gajiSkemaDireksiStore = useGajiSkemaDireksiStore();
    const gajiSkemaTetapStore = useGajiSkemaTetapStore();
    const gajiSkemaCapegStore = useGajiSkemaCapegStore();
    const gajiSkemaHonorStore = useGajiSkemaHonorStore();
    const gajiSkemaKontrakStore = useGajiSkemaKontrakStore();

    return {
      commonStore,
      golonganStore,
      jabatanStore,
      bagianStore,
      bidangStore,
      subBagianStore,
      subBidangStore,
      seksiStore,
      cabangStore,
      unitStore,
      gajiStatusStore,
      gajiPokokSkemaStore,
      gajiSkemaDireksiStore,
      gajiSkemaTetapStore,
      gajiSkemaCapegStore,
      gajiSkemaHonorStore,
      gajiSkemaKontrakStore,
    };
  },

  data() {
    return {
      rowClickData: null,
      rowClickRef: null,
      pegawaiIdClick: null,
      gajiPokokSkemaSource: null,
      gajiSkemaDireksiSource: null,
      gajiSkemaTetapSource: null,
      gajiSkemaCapegSource: null,
      gajiSkemaHonorSource: null,
      gajiSkemaKontrakSource: null,
      calendarMonthYear: {
        maxZoomLevel: "year",
        minZoomLevel: "century",
      },
      gajiStatusSource: null,
      popupWarningVisible: false,
      popupWarningContent: null,
      popupWarningTitle: null,
      opacitySalah: 1, // Initial opacity value
      opacityApproved: 1, // Initial opacity value
      opacityJmlPegawai: 1, // Initial opacity value

      mode: "select",
      searchEnabled: true,
      allowSelectAll: true,
      selectByClick: true,
      recursive: true,
      editorOptions: { placeholder: "Search column" },
      cariNamaPegawai: null,
      stylingMode: "outlined",
      //outlined, filled, underlined
      labelMode: "floating",
      cabangSource: null,
      unitSource: null,
      jabatanSource: null,
      bagianSource: null,
      bidangSource: null,
      subBagianSource: null,
      subBidangSource: null,
      golonganSource: null,
      seksiSource: null,

      router: router,
      statusButtonIcon: null,
      statusButtonType: null,
      numberingPageSize: 10,
      numberingPageNumber: 0,
      dataSourceTetap: null,
      dataSourceHonor: null,
      dataSourceKontrak: null,
      dataSourceDireksi: null,
      tabPanelIndex: 0,
      loop: false,
      animationEnabled: true,
      swipeEnabled: false,
      tabSource: tabSource,
      popupRefreshAllGajiVisible: false,
      popupLoadingVisible: false,
      editedSource: [
        { val: true, nama: "Diedit user" },
        { val: false, nama: "Dibuat sistem" },
      ],
      statusPtkpSource: [
        { nama: "" },
        { nama: "TK" },
        { nama: "K0" },
        { nama: "K1" },
        { nama: "K2" },
        { nama: "K3" },
      ],

      filterValue: [],

      currentFilter: [
        {
          key: "auto",
          name: "Immediately",
        },
      ],
      calculateFilterMK: function (
        filterValue,
        selectedFilterOperation,
        target
      ) {
        if (selectedFilterOperation === "contains" && target == "filterRow") {
          const currentDate = DateTime.now();
          const mkDate = currentDate.minus({ years: filterValue });
          var filterExpression = [
            "year(" +
              this.dataField +
              ") ge " +
              mkDate.year +
              " and " +
              "year(" +
              this.dataField +
              ") le " +
              currentDate.year,
          ];

          return filterExpression;
        }
      },
      filterOperations: ["=", "<>", ">", "<", "between"],
      calculateFilterExpression: function (
        filterValue,
        selectedFilterOperation,
        target
      ) {
        let column = this;
        if (selectedFilterOperation === "=" && target == "filterBuilder") {
          let bulan = filterValue.getMonth() + 1;
          var filterExpression = [
            "month(" +
              column.dataField +
              ") eq " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression;
        }
        if (selectedFilterOperation === "<>" && target == "filterBuilder") {
          //notequal
          let bulan = filterValue.getMonth() + 1;
          var filterExpression2 = [
            "month(" +
              column.dataField +
              ") ne " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") ne " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression2;
        }
        if (selectedFilterOperation === "<" && target == "filterBuilder") {
          //less than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression3 = [
            "year(" +
              column.dataField +
              ") lt " +
              filterValue.getFullYear().toString() +
              " or (year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString() +
              " and month(" +
              column.dataField +
              ") lt " +
              bulan +
              ")",
          ];
          return filterExpression3;
        }
        if (selectedFilterOperation === ">" && target == "filterBuilder") {
          //greater than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression4 = [
            "year(" +
              column.dataField +
              ") gt " +
              filterValue.getFullYear().toString() +
              " or (year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString() +
              " and month(" +
              column.dataField +
              ") gt " +
              bulan +
              ")",
          ];
          return filterExpression4;
        }

        if (
          selectedFilterOperation === "between" &&
          target == "filterBuilder"
        ) {
          // (year(Date) eq 2022 and month(Date) ge 5) or (year(Date) eq 2023 and month(Date) le 6)
          let bulan1 = filterValue[0].getMonth() + 1;
          let bulan2 = filterValue[1].getMonth() + 1;

          var filterExpression5 = [
            "month(" +
              column.dataField +
              ") ge " +
              bulan1 +
              " and year(" +
              column.dataField +
              ") ge " +
              filterValue[0].getFullYear() +
              " and " +
              "month(" +
              column.dataField +
              ") le " +
              bulan2 +
              " and year(" +
              column.dataField +
              ") le " +
              filterValue[1].getFullYear(),
          ];
          return filterExpression5;
        }

        // Invokes the default filtering behavior
        return column.defaultCalculateFilterExpression(arguments);
      },

      cancelButtonOptions: {
        text: "Close",
        type: "danger",
        onClick: () => {
          this.popupWarningVisible = false;
          this.popupRefreshAllGajiVisible = false;
        },
      },
      // popupWarningClicked: null,
      popupWarningStatusId: null,
      confirmButtonRefreshAllGajiOptions: {
        text: "Hitung Ulang Seluruh Gaji",
        onClick: () => {
          // this.popupRefreshAllGajiVisible = false; sementara disable
          this.refreshAllGaji();
        },
      },
      confirmButtonOptionsWarning: {
        text: "Confirm",
        onClick: () => {
          this.popupWarningVisible = false;
        },
      },
    };
  },
  async created() {
    await this.commonStore.preloadStores();
  },

  async mounted() {
    this.getUrlFilter();
    this.gajiStatusSource = await this.gajiStatusStore.get();

    this.gajiPokokSkemaSource = await this.gajiPokokSkemaStore.get();
    this.gajiSkemaDireksiSource = await this.gajiSkemaDireksiStore.get();
    this.gajiSkemaTetapSource = await this.gajiSkemaTetapStore.get();
    this.gajiSkemaCapegSource = await this.gajiSkemaCapegStore.get();
    this.gajiSkemaHonorSource = await this.gajiSkemaHonorStore.get();
    this.gajiSkemaKontrakSource = await this.gajiSkemaKontrakStore.get();

    this.golonganSource = await this.golonganStore.get();
    this.jabatanSource = await this.jabatanStore.get();
    this.bagianSource = await this.bagianStore.get();
    this.bidangSource = await this.bidangStore.get();
    this.subBagianSource = await this.subBagianStore.get();
    this.subBidangSource = await this.subBidangStore.get();
    this.seksiSource = await this.seksiStore.get();
    this.cabangSource = await this.cabangStore.get();
    this.unitSource = await this.unitStore.get();
    this.dataSourceDireksi = this.fetchDataSourceDireksi();
    this.dataSourceTetap = this.fetchDataSourceTetap();
    this.dataSourceHonor = this.fetchDataSourceHonor();
    this.dataSourceKontrak = this.fetchDataSourceKontrak();
  },
  methods: {
    getUrlFilter() {
      if (this.$route.query.filter) {
        let filter = this.$route.query.filter;
        if (!isNaN(filter[2]) && typeof +filter[2] === "number") {
          // alert("The third element is a number");
          filter[2] = parseInt(this.$route.query.filter[2]);
        }

        return filter;
      } else {
        return null;
      }
    },
    lihatGajiPegawai(e) {
      const result = e.validationGroup.validate();

      if (!result.isValid) return 0;

      this.filterValue = [["pegawai.nama", "contains", this.cariNamaPegawai]];

      if (
        this.$refs["gridRefDireksi"] &&
        this.$refs["gridRefDireksi"].instance
      ) {
        this.$refs["gridRefDireksi"].instance.getDataSource().reload();
      }
      if (this.$refs["gridRefTetap"] && this.$refs["gridRefTetap"].instance) {
        this.$refs["gridRefTetap"].instance.getDataSource().reload();
      }
      if (this.$refs["gridRefHonor"] && this.$refs["gridRefHonor"].instance) {
        this.$refs["gridRefHonor"].instance.getDataSource().reload();
      }
      if (
        this.$refs["gridRefKontrak"] &&
        this.$refs["gridRefKontrak"].instance
      ) {
        this.$refs["gridRefKontrak"].instance.getDataSource().reload();
      }
    },

    resetFilter() {
      this.filterValue = [];
      if (
        this.$refs["gridRefDireksi"] &&
        this.$refs["gridRefDireksi"].instance
      ) {
        this.$refs["gridRefDireksi"].instance.getDataSource().reload();
      }
      if (this.$refs["gridRefTetap"] && this.$refs["gridRefTetap"].instance) {
        this.$refs["gridRefTetap"].instance.getDataSource().reload();
      }
      if (this.$refs["gridRefHonor"] && this.$refs["gridRefHonor"].instance) {
        this.$refs["gridRefHonor"].instance.getDataSource().reload();
      }
      if (
        this.$refs["gridRefKontrak"] &&
        this.$refs["gridRefKontrak"].instance
      ) {
        this.$refs["gridRefKontrak"].instance.getDataSource().reload();
      }
    },

    templateUpdateByUser(data) {
      if (data.data.editedByUser) {
        return data.data.editedByUser.name + " " + data.data.updated_at;
      }
      return;
    },

    rowPrepared(e) {
      if (e.rowType === "data" && e.data) {
        if (e.data.tandai_salah) {
          e.rowElement.classList.add("class-tandai-salah");
          e.cells.forEach((cell) => {
            if ("cellElement" in cell) {
              cell.cellElement.classList.add("class-tandai-salah");
            }
          });
        }
      }
    },

    async refreshAllGrid() {
      this.dataSourceDireksi = this.fetchDataSourceDireksi();
      this.dataSourceTetap = this.fetchDataSourceTetap();
      this.dataSourceHonor = this.fetchDataSourceHonor();
      this.dataSourceKontrak = this.fetchDataSourceKontrak();
    },

    fetchDataSourceDireksi() {
      let filterOdata = [
        ["pegawai_status_id", 1],
        ["proyeksi", false],
        ["status_gaji", true],
      ];

      const odataStore = new DataSource({
        store: new ODataStore({
          url: `${ODATA_BASE_URL}/Gajis`,
          key: "id",
          version: 4,
          beforeSend: function (e) {
            e.headers = {
              "odata-version": "4.0",
            };
            if (e.method == "PATCH") {
              e.payload.edited_by_user = true;
            }
            if (typeof e.params.$filter == "undefined") {
              // e.params.$filter = "month(tgl) eq '5' and year(tgl) eq '2023'";
              e.params.$filter = getUrlFilter();
            }
            if (hasFilterNestedTable(e.params.$filter)) {
              e.params.$filter = convertFilter(
                e.params.$filter,
                "riwayatPekerjaan"
              );
              e.params.$filter = convertFilter(e.params.$filter, "riwayatPlt");
              e.params.$filter = convertFilterPegawai(e.params.$filter);
            }

            if (typeof e.params.$orderby == "undefined") {
              e.params.$orderby = "pegawai_id asc";
            } else {
              var newSortString = _(e.params.$orderby.split(","))
                .filter((criteria) => criteria.trim() !== "id")
                .join(",");
              if (newSortString === "")
                e.params.$orderby = newSortString + "pegawai_id asc";
              else e.params.$orderby = newSortString + ",pegawai_id asc";
            }
          },
        }),

        filter: filterOdata,
        //direksi
        expand: [
          "riwayatPekerjaan",
          "pegawai",
          "absenBulan",
          "riwayatPlt",
          "editedByUser",
          "gajiPeriode",
        ],
      });
      return odataStore;
    },
    fetchDataSourceTetap() {
      let filterOdata = [
        [["pegawai_status_id", 2], "or", ["pegawai_status_id", 3]],
        ["proyeksi", false],
        ["status_gaji", true],
      ];

      // Add additional filter if filterValue is not empty
      if (this.filterValue.length > 0) {
        //filterOdata = filterOdata.concat(this.filterValue);
      }
      const odataStore = new DataSource({
        store: new ODataStore({
          url: `${ODATA_BASE_URL}/Gajis`,
          key: "id",
          version: 4,
          beforeSend: function (e) {
            e.headers = {
              "odata-version": "4.0",
            };
            if (e.method == "PATCH") {
              e.payload.edited_by_user = true;
            }
            if (hasFilterNestedTable(e.params.$filter)) {
              e.params.$filter = convertFilter(
                e.params.$filter,
                "riwayatPekerjaan"
              );
              e.params.$filter = convertFilter(e.params.$filter, "riwayatPlt");
              e.params.$filter = convertFilterPegawai(e.params.$filter);
            }
            if (typeof e.params.$orderby == "undefined") {
              e.params.$orderby = "pegawai_id asc";
            } else {
              var newSortString = _(e.params.$orderby.split(","))
                .filter((criteria) => criteria.trim() !== "id")
                .join(",");
              if (newSortString === "")
                e.params.$orderby = newSortString + "pegawai_id asc";
              else e.params.$orderby = newSortString + ",pegawai_id asc";
            }
          },
        }),

        filter: filterOdata, //tetap n capeg
        expand: [
          "riwayatPekerjaan",
          "pegawai",
          "absenBulan",
          "riwayatPlt",
          "editedByUser",
          "gajiPeriode",
        ],
      });
      return odataStore;
      // const data = await odataStore.load({});
      // return data;
    },

    fetchDataSourceHonor() {
      let filterOdata = [
        ["pegawai_status_id", 4],
        ["proyeksi", false],
        ["status_gaji", true],
      ];

      // Add additional filter if filterValue is not empty
      if (this.filterValue.length > 0) {
        // filterOdata = filterOdata.concat(this.filterValue);
      }

      const odataStore = new DataSource({
        store: new ODataStore({
          url: `${ODATA_BASE_URL}/Gajis`,
          key: "id",
          version: 4,
          beforeSend: function (e) {
            e.headers = {
              "odata-version": "4.0",
            };
            if (e.method == "PATCH") {
              e.payload.edited_by_user = true;
            }
            if (hasFilterNestedTable(e.params.$filter)) {
              e.params.$filter = convertFilter(
                e.params.$filter,
                "riwayatPekerjaan"
              );
              e.params.$filter = convertFilter(e.params.$filter, "riwayatPlt");
              e.params.$filter = convertFilterPegawai(e.params.$filter);
            }
            if (typeof e.params.$orderby == "undefined") {
              e.params.$orderby = "pegawai_id asc";
            } else {
              var newSortString = _(e.params.$orderby.split(","))
                .filter((criteria) => criteria.trim() !== "id")
                .join(",");
              if (newSortString === "")
                e.params.$orderby = newSortString + "pegawai_id asc";
              else e.params.$orderby = newSortString + ",pegawai_id asc";
            }
          },
        }),

        filter: filterOdata, //honor
        expand: [
          "riwayatPekerjaan",
          "pegawai",
          "absenBulan",
          "riwayatPlt",
          "editedByUser",
          "gajiPeriode",
        ],
      });
      return odataStore;
    },

    fetchDataSourceKontrak() {
      let filterOdata = [
        ["pegawai_status_id", 5],
        ["proyeksi", false],
        ["status_gaji", true],
      ];

      // Add additional filter if filterValue is not empty
      if (this.filterValue.length > 0) {
        // filterOdata = filterOdata.concat(this.filterValue);
      }
      const odataStore = new DataSource({
        store: new ODataStore({
          url: `${ODATA_BASE_URL}/Gajis`,
          key: "id",
          version: 4,
          beforeSend: function (e) {
            e.headers = {
              "odata-version": "4.0",
            };
            if (e.method == "PATCH") {
              e.payload.edited_by_user = true;
            }
            if (hasFilterNestedTable(e.params.$filter)) {
              e.params.$filter = convertFilter(
                e.params.$filter,
                "riwayatPekerjaan"
              );
              e.params.$filter = convertFilter(e.params.$filter, "riwayatPlt");
              e.params.$filter = convertFilterPegawai(e.params.$filter);
            }
            if (typeof e.params.$orderby == "undefined") {
              e.params.$orderby = "pegawai_id asc";
            } else {
              var newSortString = _(e.params.$orderby.split(","))
                .filter((criteria) => criteria.trim() !== "id")
                .join(",");
              if (newSortString === "")
                e.params.$orderby = newSortString + "pegawai_id asc";
              else e.params.$orderby = newSortString + ",pegawai_id asc";
            }
          },
        }),

        filter: filterOdata, //kontrak
        expand: [
          "riwayatPekerjaan",
          "pegawai",
          "absenBulan",
          "riwayatPlt",
          "editedByUser",
          "gajiPeriode",
        ],
      });
      return odataStore;
    },

    calculateCellMK(e) {
      //TODO nyari masa kerja bukan dari tgl sekarang, melainkan tgl pembuatan gaji
      const today = DateTime.fromISO(e.tgl_gaji);
      const tglMulaiKerja = DateTime.fromISO(e.pegawai.tgl_mulai_bekerja);

      const month = tglMulaiKerja.month + 1; // Months are zero-based, so add 1
      const year = tglMulaiKerja.year;

      var tglMk;
      if ((month >= 11 && month <= 12) || (month >= 1 && month <= 4)) {
        // If the month is between November and April (inclusive), set the date to April 1st
        tglMk = DateTime.fromObject({ year: year, month: 4, day: 1 });
      } else if (month >= 3 && month <= 10) {
        // If the month is between March and October (inclusive), set the date to October 1st
        tglMk = DateTime.fromObject({ year: year, month: 10, day: 1 });
      } else {
        // Handle other cases as needed
        tglMk = tglMulaiKerja;
      }
      return Math.floor(today.diff(tglMk, "years").years);
    },

    can,
    refreshDatagrid(gridRef) {
      this.$refs[gridRef].instance.getDataSource().reload();
    },
    onContextMenuPreparing(e) {
      if (e.target == "content") {
        // e.items can be undefined
        if (e.row.isEditing) return;
        if (!e.items) e.items = [];

        e.items.push({
          text: "Lihat Detail Pegawai",
          icon: "user",
          onItemClick: () => {
            this.detailPegawai(e);
            // e.component.editRow(e.component.getRowIndexByKey(item));
          },
        });
        e.items.push({
          text: "Lihat Absensi",
          icon: "event",
          onItemClick: () => {
            this.detailAbsen(e);
            // e.component.editRow(e.component.getRowIndexByKey(item));
          },
        });
      }
    },

    detailAbsen(e) {
      const url = this.$router.resolve({
        name: "absen-list-custom",
        query: {
          // filter: ["pegawai_id", "=", e.row.data.pegawai_id],
          // filterPeriode: ["periode_absen", "=", e.row.data.gajiPeriode.tgl],
          filter: ["absen_bulans_id", "=", e.row.data.absen_bulan_id],
        },
      }).href;
      window.open(url, "_blank");
    },
    detailPegawai(e) {
      // this.$router.push({
      //   name: "simpeg-pegawai-detail",
      //   query: { id: e.row.data.pegawai_id },
      // });
      const url = this.$router.resolve({
        name: "pegawai-detail-custom",
        query: { id: e.row.data.pegawai_id },
      }).href;
      window.open(url, "_blank");
    },

    oneditorpreparing: function (e) {
      if (e.parentType === "dataRow") {
        if (e.row.data.status_gaji) e.editorOptions.disabled = true;
        else {
          if (e.class == "noteditable") e.editorOptions.disabled = true;
          else if (e.class == "noteditable-gaji" && this.can("gaji-update"))
            e.editorOptions.disabled = false;
          else if (e.class == "noteditable-gaji" && !this.can("gaji-update"))
            e.editorOptions.disabled = true;
          else if (e.class == "noteditable-ket" && this.can("gaji-approve"))
            e.editorOptions.disabled = false;
          else if (e.class == "noteditable-ket" && !this.can("gaji-approve"))
            e.editorOptions.disabled = true;
        }
      }

      if (e.dataField === "tgl_gaji") {
        e.editorOptions.calendarOptions = {
          minZoomLevel: "year",
          maxZoomLevel: "year",
          displayFormat: "MM/yyyy",
          type: "month",
        };
      }
    },

    formatNumber(value) {
      if (value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return value;
    },
    calculateDisplayMK(e) {
      const today = DateTime.fromISO(e.tgl_gaji);
      const date2 = DateTime.fromISO(e.riwayatGolongan.tgl_mulai_bekerja);
      return Math.floor(today.diff(date2, "years").years) + " tahun";
    },
    formatMasaKerja(e) {
      const today = DateTime.local().setLocale("id"); //TODO nyari masa kerja bukan dari tgl sekarang, melainkan tgl pembuatan gaji
      const date2 = DateTime.fromISO(e);
      return Math.floor(today.diff(date2, "years").years);
    },
    formatMonthTitle(e) {
      const date = DateTime.fromISO(e).setLocale("id");
      return date.monthLong + " " + date.year;
    },
    formatMonth(e) {
      const isoDateString = e.split("/").reverse().join("-") + "-01";
      const date = DateTime.fromISO(isoDateString).setLocale("id");

      return date.monthLong + " " + date.year;
    },
    onPageChanged(e, gridRef) {
      if (e.fullName == "paging.pageIndex") {
        this.numberingPageSize = this.$refs[gridRef].instance.pageSize();
        this.numberingPageNumber = e.value;
      }
    },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Gaji");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Gaji " + this.tabSource[this.tabPanelIndex].text + ".xlsx"
          );
        });
      });
      e.cancel = true;
    },
  },
};
</script>
